import React from "react";
import Copyright from "../components/footer/Copyright";
import NavbarTwo from "../components/NavbarTwo";
import TermsConditionsRepo from "../repository/TncRepo";

const TermsConditions = () => {
  let bgImage = process.env.PUBLIC_URL + "assets/media/bg-image-2.4b2b6c28.JPG";

  return (
    <>
      <NavbarTwo />
      <div
        className="page-are"
        style={{
          minHeight: "100vh",
          backgroundImage: `url(${bgImage})`,
          backgroundRepeat: `no-repeat`,
          backgroundPosition: `top`,
          backgroundSize: `cover`,
        }}
      >
        <div className="page-bg">
          <div
            className="container"
            style={{ paddingBottom: "100px", paddingTop: "118px" }}
          >
            <div className="row">
              <div className="col-lg-12 border border-secondary">
                <div className="section-title mb--40">
                  <h2 className="text-white mt-4 text-center">
                    <span className="theme-color">Terms &amp; </span> Conditions
                  </h2>
                  {TermsConditionsRepo.tnc.map((tnc, index) => (
                    <div key={index}>
                      <p>&nbsp;&nbsp;</p>
                      <h3 className="text-light">{tnc.title}</h3>
                      <div className="text-white">{tnc.description}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <Copyright />
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
